import React, { useState } from "react";
import { Button, Card, Form, Icon, Input, Select } from "antd";
import { product } from "../../../config/constants";
import { useTranslation } from 'react-i18next';

const LoginForm = (props) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    login: "",
    password: "",
    mfaAuthentication: "",
    lang: props.language.replace("-", "_"),
    loginError: "",
    passwordError: "",
    mfaAuthenticationError: "",
  });

  const handleLogin = (e) => {

    e.preventDefault();

    const errors = {};

    if (!formData.login) {
      errors.loginError = t("common.login.form.email.required")
    }

    if (!formData.password) {
      errors.passwordError = t("common.login.form.password.required")
    }

    if (checkMfaAuthentication === 1 && !formData.mfaAuthentication) {
      errors.mfaAuthenticationError = t("common.authentication.required");
    }

    if (formData.mfaAuthentication && formData.mfaAuthentication.includes(' ')) {
      errors.mfaAuthenticationError = t("devices.template.provisioning.error.validate.error")
    }

    if (Object.keys(errors).length === 0) {
      props.handleLogin(formData);
      setFormData({
        ...formData,
        mfaAuthenticationError: "",
        loginError: "",
        passwordError: "",
      });
    } else {
      setFormData({ ...formData, ...errors });
    }
  };

  const handleChange = (lang) => {
    if (lang) {
      formData.lang = lang
      props.handleChangeLang(lang);
    }
  };


  const maskPassword = (e) => {
    const input = e.target.value;
    let passwordAux;

    if (e.type === "paste") { // Lidar com a colagem de texto (Ctrl + V)

      const pastedText = (e.clipboardData || window.clipboardData).getData("text");
      let cleanedText = pastedText.trim();
      cleanedText = cleanedText.replace(/[\s\n\r\t]/g, '');

      passwordAux = cleanedText.slice(0, -1);;
      return setFormData({ ...formData, password: passwordAux, passwordWithMask: '*'.repeat(passwordAux.length) });

    } else {
      // Lidar com outros eventos de entrada de texto
      if (input.length < formData.password.length) {
        passwordAux = formData.password.slice(0, input.length);
      } else if (input === "") {
        passwordAux = input;
      } else {
        passwordAux = formData.password + input.charAt(input.length - 1);
      }
    }

    setFormData({ ...formData, password: passwordAux, passwordWithMask: '*'.repeat(passwordAux.length) });
  };



  const {
    forgotPasswordBtn,
    forgotPassword,
    languages,
    lockForm,
    loginPlaceholder,
    passwordPlaceholder,
    onToggle,
    onSSO,
    checkMfaAuthentication,
    sso_enabled
  } = props;

  let fieldLock = {};
  if (lockForm)
    fieldLock = { hasFeedback: true, disabled: true, validateStatus: "validating" };

  return (
    <Form onSubmit={handleLogin} style={{ textAlign: "left" }} autoComplete="on">
      <Card className="login-card-content">
        <Form.Item {...fieldLock}
          hasFeedback
          validateStatus={formData.loginError ? "error" : ""}
          help={formData.loginError}
        >
          <Input
            size="large"
            disabled={lockForm}
            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder={loginPlaceholder}
            data-testid="loginForm_login"
            value={formData.login}
            onChange={(e) => setFormData({ ...formData, login: e.target.value })}
          />
        </Form.Item>
        <Form.Item {...fieldLock}
          hasFeedback
          validateStatus={formData.passwordError ? "error" : ""}
          help={formData.passwordError}
        >
          <Input
            size="large"
            disabled={lockForm}
            prefix={<Icon type="lock"
              style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder={passwordPlaceholder}
            type="password"
            data-testid="loginForm_password"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            autoComplete="on"
          />
        </Form.Item>
        {checkMfaAuthentication == 1 && <Form.Item {...fieldLock}
          hasFeedback
          validateStatus={formData.mfaAuthenticationError ? "error" : ""}
          help={formData.mfaAuthenticationError}
        >
          <Input
            size="large"
            disabled={lockForm}
            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder={"MFA Authentication"}
            type="text"
            value={formData.mfaAuthentication}
            onChange={(e) =>
              setFormData({ ...formData, mfaAuthentication: e.target.value })
            }
          />
        </Form.Item>}
        {languages.length > 1 && <Form.Item {...fieldLock}>
          <Select
            size="large"
            disabled={lockForm}
            placeholder="Language"
            onChange={handleChange}
            value={formData.lang}
          >
            {languages.map((item) => {
              return <Select.Option key={item.value} value={item.value}>{item.text}</Select.Option>
            })}
          </Select>
        </Form.Item>}
        <Button disabled={lockForm} size="large" block type="primary" htmlType="submit" className="login-form-button">Login</Button>
      </Card>
      {product == "GSM" && sso_enabled && <p><Button disabled={lockForm} onClick={onSSO} size="large" ghost type="primary" block className="login-form-button color-white">Single-Sign-On</Button></p>}
      {forgotPassword && <p><Button disabled={lockForm} onClick={onToggle} size="large" ghost type="primary" block className="login-form-button color-white">{forgotPasswordBtn}</Button></p>}
    </Form>
  );
}

export default Form.create({ name: "loginForm" })(LoginForm);